import {
  SignedFile,
  uploadSignedFilesToBucket,
} from "@coworker/apprestructured/src/task-management/services/uploads.service";
import { useMutation } from "@tanstack/react-query";

export const useUploadFilesToBucket = () => {
  return useMutation({
    mutationFn: (signedFiles: SignedFile[]) =>
      uploadSignedFilesToBucket(signedFiles),
  });
};
